import { useRecoilValue } from "recoil"

import { usersSelector } from "../../recoil/atoms/users"
import { useLocalUserType } from "../useLocalUserType"
import { mainWindowUserSelector } from "../../recoil/atoms/mainWindowUser"
import { someHaveOnDeviceSelector } from "../../recoil/selectors/some-have-on-selectors"


export function useIsAudienceAndMeetingLive() {
    const isAnyUserHasOnDevice = useRecoilValue(someHaveOnDeviceSelector)
    const { isAudience, isBroadcaster } = useLocalUserType()

    const audienceShouldFocus = isAnyUserHasOnDevice && (isAudience || isBroadcaster)
    return audienceShouldFocus
}

export function useIsModLive() {
    const mainWindowUser = useRecoilValue(mainWindowUserSelector)
    const mainWindowUserDetails = useRecoilValue(
        usersSelector(mainWindowUser.uid?.replace("ss", "").trim())
    )

    const modIsLive = (mainWindowUserDetails?.camEnabled || mainWindowUserDetails?.micEnabled || !!mainWindowUserDetails?.screenShareEnabled)
    return modIsLive
}

